'use strict';

var cov_102azfpc7f = function () {
  var path = 'D:\\raw\\vina_giaitri365\\vnp_365_client\\src\\app\\print\\print.js',
      hash = '7a323694abb094b6e851a9eb88afbe83f40c9800',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\raw\\vina_giaitri365\\vnp_365_client\\src\\app\\print\\print.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 30
        }
      },
      '1': {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 7,
          column: 7
        }
      },
      '2': {
        start: {
          line: 6,
          column: 6
        },
        end: {
          line: 6,
          column: 33
        }
      },
      '3': {
        start: {
          line: 12,
          column: 0
        },
        end: {
          line: 17,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 67
          },
          end: {
            line: 9,
            column: 3
          }
        },
        line: 2
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 5,
            column: 39
          },
          end: {
            line: 5,
            column: 40
          }
        },
        loc: {
          start: {
            line: 5,
            column: 49
          },
          end: {
            line: 7,
            column: 5
          }
        },
        line: 5
      }
    },
    branchMap: {},
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0
    },
    f: {
      '0': 0,
      '1': 0
    },
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PrintController = function PrintController($scope, apiOpen, $http, $rootScope, $window, myVars) {
  _classCallCheck(this, PrintController);

  cov_102azfpc7f.f[0]++;
  cov_102azfpc7f.s[0]++;

  $scope.checkinfo = myVars;
  // $scope.reload = function () {
  cov_102azfpc7f.s[1]++;
  $http.get(apiOpen + 'header').then(function (result) {
    cov_102azfpc7f.f[1]++;
    cov_102azfpc7f.s[2]++;

    $scope.print = result.data;
  });
  // }
};

cov_102azfpc7f.s[3]++;


angular.module('app').component('print', {
  templateUrl: 'app/print/print.html',
  controller: PrintController
});